import '@nextapps-be/livewire-sortablejs';

import './bootstrap';
import './attachments-gallery.js';
import './sentry.js';

document.addEventListener('DOMContentLoaded', () => toggleSectionCollapsibleEvent());
window.addEventListener('resize', () => toggleSectionCollapsibleEvent());

/**
 * Toggle the collapsible event for the weekly calendar sections based on the window width
 */
function toggleSectionCollapsibleEvent() {
    const calendarSections = document.querySelectorAll('.weekly-calendar-section');

    if (calendarSections.length > 0) {
        if (window.innerWidth < 1024) {
            calendarSections.forEach((section) => {
                if (section.querySelector('.fi-section-content').childElementCount === 0) {
                    section.firstElementChild.click();
                    section.firstElementChild.removeAttribute('x-on:click');
                    section.firstElementChild.querySelector('button').classList.add('hidden');
                } else {
                    section.firstElementChild.setAttribute('x-on:click', 'isCollapsed = ! isCollapsed');
                    section.firstElementChild.querySelector('button').classList.remove('hidden');
                }
            });
        } else {
            calendarSections.forEach((section) => {
                section.firstElementChild.removeAttribute('x-on:click');
                section.firstElementChild.querySelector('button').classList.add('hidden');
            });
        }
    }
}
